let getYearsByCollection = async ({ url, collection_id }) => {
  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      query: `{
        collectionById(id: "${collection_id}") {
          facetIssuedYear
        }
      }`,
    }),
  })
    .then((response) => response.json())
    .then((response) => response.data.collectionById.facetIssuedYear);
};

let getBulletinsByYear = async ({
  url,
  collection_id,
  year = "",
  currentPage = 1,
  itemsPerPage = 20,
  query = `{
    collectionById(id: "${collection_id}") {
      name
      items(
        first: ${itemsPerPage}
        page: ${currentPage}
        hasMetadata: {
          AND: [
            { column: METADATA_FIELD_ID, operator:EQ, value: 15 }
            { column: VALUE, operator:LIKE, value: "${year}%" }
          ]
        }
      ) {
        paginatorInfo {
          count
          currentPage
          hasMorePages
          total
          perPage
        }
        data {
          id
          handle
          url
          metadata{
            metadata_field_id
            element
            qualifier
            value
          }
        }
      }
    }
  }`,
}) => {
  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      query: query,
    }),
  })
    .then((response) => response.json())
    .then((response) => response.data.collectionById);
};

export { getBulletinsByYear, getYearsByCollection };
